module.exports = __webpack_public_path__ + "static/media/04.a72f0120.jpg";